import {
  Box,
  Button,
  Divider,
  IconButton,
  Paper,
  Typography,
} from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { useLocation, useNavigate } from 'react-router';
import { useState } from 'react';
import { shippingMethods } from './checkoutData';
import '../Customer/CustomerScreens.scss';

export default function ShippingSelection() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedShippingId, setSelectedShippingId] = useState(
    location.state?.shipping?.id || shippingMethods[0].id
  );

  const selectedShipping =
    shippingMethods.find((item) => item.id === selectedShippingId) || shippingMethods[0];

  return (
    <Box className='customer-screen'>
      <Box className='customer-shell'>
        <Box className='customer-topbar'>
          <IconButton className='customer-iconButton' onClick={() => navigate(-1)}>
            <ArrowBackRoundedIcon />
          </IconButton>
          <Typography className='customer-topbarTitle'>Choose Shipping</Typography>
          <Box sx={{ width: 46 }} />
        </Box>

        <Paper className='customer-card' sx={{ p: 2 }}>
          <Box className='checkout-optionList'>
            {shippingMethods.map((item, index) => {
              const isActive = item.id === selectedShippingId;

              return (
                <Box key={item.id}>
                  <Box
                    className='checkout-optionRow'
                    component='button'
                    onClick={() => setSelectedShippingId(item.id)}
                    sx={{ border: 0, width: '100%', background: 'transparent', cursor: 'pointer' }}
                  >
                    <Box className='checkout-optionMain'>
                      <Box className='customer-menuIcon'>
                        <Inventory2OutlinedIcon fontSize='small' />
                      </Box>
                      <Box sx={{ textAlign: 'left' }}>
                        <Typography sx={{ fontWeight: 700 }}>{item.label}</Typography>
                        <Typography className='customer-muted'>{item.eta}</Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                      <Typography sx={{ fontWeight: 700 }}>${item.amount}</Typography>
                      <Box
                        className={`checkout-radio${isActive ? ' checkout-radio--active' : ''}`}
                      />
                    </Box>
                  </Box>
                  {index < shippingMethods.length - 1 ? <Divider /> : null}
                </Box>
              );
            })}
          </Box>
        </Paper>

        <Paper className='checkout-stickyFooter'>
          <Button
            className='customer-actionButton customer-actionButton--primary'
            fullWidth
            onClick={() =>
              navigate('/checkout/review', {
                state: {
                  ...location.state,
                  shipping: selectedShipping,
                },
              })
            }
          >
            Apply
          </Button>
        </Paper>
      </Box>
    </Box>
  );
}
